export default require('../../../data/share.json');
